import request from '../request/request'



  //删除
  export function orderDeleteCart(query) {
    return request({
      url: `/cart/orderDeleteCart`,
      method: 'post',
      data:query
    })
  }

//获取电子普通发票
export function listInvoice(query) {
    return request({
      url: `/invoice/listInvoice`,
      method: 'post',
      data:query
    })
  }
  

 
export function updateInvoiceSpuName(query) {
    return request({
      url: `/cart/updateInvoiceSpuName`,
      method: 'post',
      data:query
    })
  }


  
  export function insertInvoice(query) {
    return request({
      url: `/invoice/insertInvoice`,
      method: 'post',
      data:query
    })
  }


  //编辑
  export function updateInvoice(query) {
    return request({
      url: `/invoice/updateInvoice`,
      method: 'post',
      data:query
    })
  }

  //删除
  export function deleteInvoice(query) {
    return request({
      url: `/invoice/deleteInvoice`,
      method: 'post',
      data:query
    })
  }


  export function listaddDZ(query) {
    return request({
      url: `/address/list`,
      method: 'post',
      data:query
    })
  }
 

  export function CompanyInvInfoByCode(code) {
    return request({
      url: `/invoice/getCompanyInvInfoByCode/${code} `,
      method: 'get',
      data:{}
    })
  }
  
 
  export function CompanyCodeByKeyWord(keyWord) {
    return request({
      url: `/invoice/getCompanyCodeByKeyWord/${keyWord} `,
      method: 'get',
      data:{}
    })
  }




// WEBPACK FOOTER //
// ./src/api/invoiceEditing.js